import { ReactElement } from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { Button } from 'common/components/antd/Button/Button';
import HeaderLayoutCounterpartyName
  from 'common/components/HeaderLayoutCounterpartyName/HeaderLayoutCounterpartyName.component';
import {
  SContainer,
} from './Header.style';

const HeaderComponent = (): ReactElement =>
  <SContainer>
    <div
      style={{
        display: 'flex',
      }}
    >
      <div>
        <Space size={16}>
          <HeaderLayoutCounterpartyName />
        </Space>
      </div>
    </div>

    <div>
      <Button icon={<SettingOutlined />} />
    </div>
  </SContainer>;

export default HeaderComponent;
